// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
*/

import appsUtil from '../AppsUtil';
import {
	CONFIRMATION_BOX_BTN_IDS,
	DIALOG_REPO_KEYS
} from '@ccxi/ccxi-apps/src/utils/modelMapper/appModelMapper/confirmationDialog/confirmationDialogConstants';

import {ACTION_ID} from '@ccxi/ccxi-apps/src/utils/modelMapper/appModelMapper/appModelConstants';
import {actionIds} from '../../constants/appsConstants';

import TranslationUtil from '@ccxi/ccxi-apps/src/utils/translation';

class ThorCommonUtil {
	inWaitingApps: Object;
	executedViaWAMWorkflow: boolean;
	instance: Object;

	static inWaitingApps: Object;
	static executedViaWAMWorkflow: boolean;

	constructor() {
		if (this.instance) {
			return this.instance;
		}
		this.inWaitingApps = {};
		this.executedViaWAMWorkflow = false;
	}

	shouldShowWaiting(actionId: string, operation: string) {
		switch (operation) {
			case DIALOG_REPO_KEYS.UPDATE:
			case DIALOG_REPO_KEYS.CONFLICT:
			case DIALOG_REPO_KEYS.PII: {
				if (actionId === CONFIRMATION_BOX_BTN_IDS.PRIMARY) {
					return true;
				}
			}
				break;
			case DIALOG_REPO_KEYS.UNINSTALL: {
				if (actionId === CONFIRMATION_BOX_BTN_IDS.PRIMARY || actionId === CONFIRMATION_BOX_BTN_IDS.SECONDARY) {
					return true;
				}
			}
				break;
		}
		return false;
	}

	onceExecutedViaWAMWorkflow() {
		return this.executedViaWAMWorkflow;
	}

	setExecutedViaWAMWorkflow() {
		this.executedViaWAMWorkflow = true;
	}

	setWaiting(sapcode: string, version: string) {
		const appModel = appsUtil.CCXUIAppStore[`${sapcode}_${version}`];
		if (appModel) {
			appModel.updateProgress(false, true, 0, TranslationUtil.getMessage('ccx.appAction.status.waiting'));
			this.inWaitingApps[`${sapcode}_${version}`] = true;
		}
	}
	resetWaiting(sapcode: string, version: string) {
		this.inWaitingApps[`${sapcode}_${version}`] = false;
	}

	isProductWaiting(sapcode: string, version: string) {
		return this.inWaitingApps[`${sapcode}_${version}`];
	}

	getWAMCTAs() {
		const wamActionList = [];
		wamActionList.push({
			actionId: ACTION_ID.TRY,
			localizedText: TranslationUtil.getMessage('ccx.appAction.try')
		});
		wamActionList.push({
			actionId: actionIds.download,
			localizedText: TranslationUtil.getMessage('apps.tile.download')
		});
		wamActionList.push({
			actionId: ACTION_ID.LEARN_MORE_PDP,
			localizedText: TranslationUtil.getMessage('apps.tile.learnmore')
		});
		wamActionList.push({
			actionId: ACTION_ID.INSTALL,
			localizedText: TranslationUtil.getMessage('ccx.appAction.install')
		});
		wamActionList.push({
			actionId: ACTION_ID.UPDATE,
			localizedText: TranslationUtil.getMessage('ccx.appAction.update')
		});
		wamActionList.push({
			actionId: ACTION_ID.UNINSTALL,
			localizedText: TranslationUtil.getMessage('ccx.appAction.uninstall')
		});
		wamActionList.push({
			actionId: ACTION_ID.OPEN,
			localizedText: TranslationUtil.getMessage('ccx.appAction.open')
		});
		wamActionList.push({
			actionId: ACTION_ID.START_TRIAL,
			localizedText: TranslationUtil.getMessage('ccx.appAction.trial')
		});
		wamActionList.push({
			actionId: ACTION_ID.RETRY,
			localizedText: TranslationUtil.getMessage('ccx.appAction.retry')
		});
		wamActionList.push({
			actionId: ACTION_ID.NOT_COMPATIBLE,
			localizedText: TranslationUtil.getMessage('ccx.appAction.notCompatible')
		});
		wamActionList.push({
			actionId: ACTION_ID.BUY,
			localizedText: TranslationUtil.getMessage('ccx.appAction.buy')
		});
		wamActionList.push({
			actionId: ACTION_ID.BUY_NOW,
			localizedText: TranslationUtil.getMessage('ccx.appAction.buyNow')
		});
		return wamActionList;
	}

	shouldSkipVariantCTA(actionId: string) {
		switch (actionId) {
			case ACTION_ID.NOT_COMPATIBLE:
			case ACTION_ID.TRY:
				return true;
		}
		return false;
	}
}

export default new ThorCommonUtil();
